import { render, staticRenderFns } from "./MindOrder.vue?vue&type=template&id=f0c08c14"
import script from "./MindOrder.vue?vue&type=script&lang=js"
export * from "./MindOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports